import _ from 'lodash'
import { useReducer } from 'react'
import { getBatchResult } from '../helper/batch'

const ACTIONS = {
  SET_LISTINGS: 'SET_LISTINGS',
  SET_QUERY_STRING_LISTING_IDS: 'SET_QUERY_STRING_LISTING_IDS',
  SET_BATCH_RESULT: 'SET_BATCH_RESULT',
  SET_DELETED_LISTINGS: 'SET_DELETED_LISTINGS',
  ADD_DELETED_LISTINGS: 'ADD_DELETED_LISTINGS'
}

const getInitState = () => {
  return {
    listings: [],
    deletedListings: [],
    queryStringListingIds: '',
    batchResult: getBatchResult([])
  }
}

const useListingState = () => {
  const reducer = (state, action) => {
    const { type, payload } = action
    switch (type) {
      case ACTIONS.SET_LISTINGS: {
        const newListingIdMap = _.keyBy(payload, 'id')
        const deletedListings = _.filter(state.deletedListings, listing => {
          return !(listing.id in newListingIdMap)
        })
        return { ...state, listings: payload, deletedListings }
      }
      case ACTIONS.SET_DELETED_LISTINGS:
      case ACTIONS.ADD_DELETED_LISTINGS: {
        let deletedListings = payload
        // 增加一筆新的刪除賣場資料
        if (type === ACTIONS.ADD_DELETED_LISTINGS) {
          deletedListings = [...state.deletedListings, ...deletedListings]
        }
        const deletedListingIdMap = _.keyBy(deletedListings, 'id')
        const listings = _.filter(state.listings, listing => {
          return !(listing.id in deletedListingIdMap)
        })
        return { ...state, listings, deletedListings }
      }
      case ACTIONS.SET_QUERY_STRING_LISTING_IDS:
        return { ...state, queryStringListingIds: payload }
      case ACTIONS.SET_BATCH_RESULT:
        return { ...state, batchResult: payload }
      default:
        return state
    }
  }

  const [state, dispatch] = useReducer(reducer, getInitState())

  const setListings = listings => dispatch({
    type: ACTIONS.SET_LISTINGS,
    payload: listings
  })

  const setDeletedListings = deletedListings => dispatch({
    type: ACTIONS.SET_DELETED_LISTINGS,
    payload: deletedListings
  })

  const addDeletedListings = deletedListings => dispatch({
    type: ACTIONS.ADD_DELETED_LISTINGS,
    payload: deletedListings
  })

  const setQueryStringListingIds = queryStringListingIds => dispatch({
    type: ACTIONS.SET_QUERY_STRING_LISTING_IDS,
    payload: queryStringListingIds
  })

  const setBatchResult = batchResult => dispatch({
    type: ACTIONS.SET_BATCH_RESULT,
    payload: batchResult
  })

  const actions = {
    setListings,
    setDeletedListings,
    addDeletedListings,
    setQueryStringListingIds,
    setBatchResult
  }

  return { state, actions }
}

export default useListingState
